// React
import React, { useCallback, useEffect, useState } from 'react';
import {
  Col,
  Row,
  Modal,
  Label,
  Button,
  CardFooter,
  ModalHeader,
} from 'reactstrap';

// Containers Injections
import { SelectInput, createData } from '../../containers/componentsInjection';

export const ModalEditValue = ({ isOpen2, toggle2, organizations }) => {
  const [isAllow, setIsAllow] = useState(false);

  return (
    <Modal
      id="fadeInleftModal"
      isOpen={isOpen2}
      toggle2={() => {
        toggle2();
      }}
      onClosed={() => {
        setIsAllow(false);
      }}
      modalClassName="fadeInLeft"
      size="lg"
      unmountOnClose
      centered
      autoFocus={false}
    >
      <ModalHeader>Nova Receita de Organizações</ModalHeader>
      <form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="modal-body">
          <Row className="mb-2">
            <Col xs={4} md={6} lg={12}>
              <Label for="saleAtInput" className="form-label">
                Organizações
              </Label>
              <SelectInput
                options={createData(organizations || [])}
                inputId="organization"
                className={isAllow ? 'form-control' : 'form-control  bg-light'}
                placeholder="Selecione uma organização"
                // value={validation.values.organization}
                onChange={(eventInput) => {
                  if (eventInput) {
                    setIsAllow(true);
                  }
                  // validation.handleChange(
                  //   convertEventSelectToTarget('organization', eventInput)
                  // );
                }}
                // onBlur={(eventInput) => {
                //   validation.handleBlur(
                //     convertEventSelectToTarget('organization', eventInput)
                //   );
                // }}
              />
            </Col>
          </Row>
        </div>
        <CardFooter>
          <div className="modal-footer p-0">
            <button
              className="btn btn-link"
              onClick={() => {
                toggle2();
              }}
              type="button"
            >
              {' '}
              Cancelar{' '}
            </button>
            <Button color="secondary" type="submit" disabled={!isAllow}>
              {' '}
              Calcular{' '}
            </Button>
          </div>
        </CardFooter>
      </form>
    </Modal>
  );
};
